export function validateEmails() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            var emailsRegex = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,61})$/;


            ctrl.$validators.email = (modelValue = '') => {

                if(!ctrl.$validators.required && modelValue.length == 0){

                    return true;

                }else{

                    return emailsRegex.test(modelValue.trim());

                }
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/validate-emails.directive.js